import { cfg } from "../runtimeConfig";
import { termosEnterprisePixAutomaticoVersion } from "../routes/pages/legal/content/termosEnterprise";

/** Terms version sent with a new enrollment; must equal Payments' own. */
export function pixAutomaticoTermsVersion(): string {
  return cfg.REACT_APP_PIX_AUTOMATICO_TERMS_VERSION?.trim() ?? "";
}

/**
 * Whether /termos publishes the billing conditions of this terms version. The
 * payments page offers the authorization only when it does, because Payments
 * records the version as the one the company accepted. Until legal review
 * publishes the Pix Automatico clause (termosEnterprisePixAutomaticoVersion),
 * no configured version passes.
 */
export function isPixAutomaticoTermsPublished(version: string): boolean {
  return version !== "" && version === termosEnterprisePixAutomaticoVersion;
}
